import React from 'react'
import clsx from 'clsx'
import useStyles from './styles'

export interface ButtonGroupItem {
    label: string
    value: string
}

interface ButtonGroupProps {
    className?: string
    items: ButtonGroupItem[]
    active?: ButtonGroupItem
    onChange: (item: ButtonGroupItem) => void
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({ className, items, active, onChange }) => {
    const classes = useStyles()

    return (
        <div className={clsx(classes.buttonGroup, className)}>
            {items.map(item => (
                <button
                    key={item.value}
                    className={clsx(classes.button, active === item && classes.active)}
                    onClick={e => {
                        e.preventDefault()
                        onChange(item)
                    }}
                >
                    {item.label}
                </button>
            ))}
        </div>
    )
}

export default ButtonGroup
